/** Waits between checks while the backend's scan runs: quick at first, then settling at 30s. */
const POLL_DELAYS_MS = [3000, 5000, 8000, 13000, 20000, 30000]

/** Stops checking after this many responses (about eight minutes) and uses what it has. */
export const CLIKART_PLACED_IDS_MAX_POLLS = 20

/**
 * How long to wait before asking for the placed ClikArt again, or false to stop. Only a running
 * scan is worth waiting for, and only for a bounded time — a scan that never ends must not keep
 * the editor polling for the whole session.
 *
 * @param isScanning whether the latest response said the scan is still running
 * @param responseCount how many responses (reads or the trigger's reply) have arrived so far
 */
export function nextClikArtPlacedIdsPollDelay(
  isScanning: boolean | undefined,
  responseCount: number
): number | false {
  if (!isScanning || responseCount > CLIKART_PLACED_IDS_MAX_POLLS) return false

  const index = Math.min(Math.max(responseCount - 1, 0), POLL_DELAYS_MS.length - 1)

  return POLL_DELAYS_MS[index]
}
